import React, {useContext} from "react";
import {CustomStepper} from "../common/index";
import {ContentContext} from "../../ContentContext";

function Partner() {
    const data = useContext(ContentContext);

    if (!data?.showSections.includes("partner")) {
        return null;
    }

    return (
        <section className={"additional-services"}>
            <h2>{data?.partnerTitle}</h2>
            <p dangerouslySetInnerHTML={{__html: data?.partnerDescription}} />
            <div className="container indented">
                <CustomStepper items={data?.partnerContent} />
            </div>
        </section>
    );
}

export default Partner;
